<script>
    import ThemeToggle from './ThemeToggle.svelte'

    let windowWidth
</script>

<svelte:window bind:innerWidth={windowWidth}/>

<div class="header-wrapper">
    <div class="header">
        <a class="logo-link" href="https://tools.fau-leipzig.de" rel="noopener noreferrer" target="_blank">
            <img alt="Fau-Logo" class="logo" src="logo.png">
        </a>
        <div class="title">Toolbox</div>
        <div class="header-right">
            <ThemeToggle/>
            <a class="button" class:hidden={windowWidth<840}
               href="https://addons.mozilla.org/firefox/downloads/file/3853543/fau_toolbox-4-fx.xpi">
                <img alt="firefox-icon" class="firefox-icon" src="images/firefox-logo.svg"/>
                <div class="install-btn-text">
                    Add to Firefox
                </div>
            </a>
        </div>
    </div>
</div>

<style>
    .hidden {
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px;
    }

    .header-wrapper {
        padding: 10px;
        position: sticky;
        top: 0;
        z-index: 100;
    }

    .header {
        height: 2.5em;
        padding: 1em;
        background-color: var(--theme-colors-background-headerbar);
        border-radius: 15px;
        border: solid var(--theme-colors-border) 1px;

        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
    }

    .header-right {
        display: flex;
        flex-direction: row;
        justify-content: right;
        height: inherit;
    }

    @supports ((-webkit-backdrop-filter: blur(3px)) or (backdrop-filter: blur(3px))) {
        .header {
            -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
            background: var(--theme-colors-background-blurredheaderbar);
        }
    }

    .header > .logo-link {
        height: inherit;
    }

    .header > .logo-link > .logo {
        height: inherit;
    }

    .header > .title {
        font-size: 2.2em;
        font-weight: bold;
        font-family: sans-serif;
        text-align: center;
    }

    .firefox-icon {
        margin-right: .3em;
        height: 90%;
    }
</style>